import { useQuery } from '@tanstack/react-query';
import { payoutService } from '../services/payout.service';

export const ONBOARDING_STATUS_KEY = ['seller', 'onboarding', 'status'];

export function useOnboardingStatus() {
  return useQuery({
    queryKey: ONBOARDING_STATUS_KEY,
    queryFn: () => payoutService.getOnboardingStatus(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
